<template>
  <div class="perfectingInformation">
    <div class="detailedInformation">
      <el-form
        ref="ruleForm1"
        :model="form1"
        :rules="rules1"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-card-title title="企业信息" />
        <el-form-item label="公司名称：" prop="companyName">
          <el-input
            v-model.trim="form1.companyName"
            class="input-long"
            placeholder="请输入公司名称"
            maxlength="36"
          />
          <span style="margin-left: 20px; color: #9b9b9b"
            >请按营业执照上登记的完整名称填写</span
          >
        </el-form-item>
        <el-form-item label="公司简称：" prop="companyAbbr">
          <el-input
            v-model.trim="form1.companyAbbr"
            class="input-long"
            placeholder="请输入公司简称"
            maxlength="30"
          />
        </el-form-item>
        <el-form-item label="统一社会信用代码：" prop="unifiedCode">
          <el-input
            v-model="form1.unifiedCode"
            class="input-short"
            placeholder="请输入统一社会信用代码"
            ref="idNumber"
            maxlength="18"
          />
        </el-form-item>
        <el-form-item label="注册地址：" prop="address">
          <el-input
            maxlength="200"
            v-model.trim="form1.address"
            class="input-short"
            placeholder="请输入注册地址"
          />
        </el-form-item>
        <el-form-item label="公司联系电话：" prop="businessTelephone">
          <el-input
            maxlength="30"
            v-model="form1.businessTelephone"
            class="input-short"
            placeholder="请输入公司联系电话"
          />
        </el-form-item>
        <el-form-item label="公司简介：" prop="companyDesc">
          <el-input
            resize="both"
            type="textarea"
            placeholder="请输入"
            v-model="form1.companyDesc"
            maxlength="1000"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <el-form
        ref="ruleForm4"
        :model="form4"
        :rules="rules4"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-card-title title="资质文件" />
        <p class="commonTxtTip">
          支持格式：.jpg .png .jpeg .gif 每个不超过5M，.xls .xlsx .doc .docx
          .pdf每个不超过15M
        </p>
        <span class="text">营业执照</span>
        <el-form-item label="有效期：" prop="validityStart">
          <el-date-picker
            v-model="form4.validityStart"
            type="date"
            value-format="yyyy-MM-dd"
            :picker-options="{
              disabledDate: time => {
                if (this.form4.validityEnd) {
                  return (
                    time.getTime() >
                    new Date(this.form4.validityEnd).getTime() - 86400000
                  );
                }
                return time.getTime() > Date.now();
              }
            }"
            placeholder="选择开始日期"
          >
          </el-date-picker>
          -
          <el-date-picker
            :disabled="isLongValidityStatus.isLongValidityDisabled"
            v-model="form4.validityEnd"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期"
            :picker-options="{
              disabledDate: time => {
                if (this.form4.validityStart) {
                  return (
                    time.getTime() <
                    new Date(this.form4.validityStart).getTime()
                  );
                }
              }
            }"
          >
          </el-date-picker>
          <el-checkbox
            style="margin-left: 30px"
            :value="isLongValidityStatus.isLongValidityValue"
            @change="handleValidityCheckbox"
            >长期
          </el-checkbox>
        </el-form-item>
        <el-form-item label="资质上传：" prop="busLicenseId">
          <div style="height: 88px">
            <el-file-upload
              :on-change="
                (file, fileList) => {
                  changeFile(1, file, fileList);
                }
              "
              :on-success="
                (response, file, fileList) => {
                  handleSuccess(1, response, file, fileList);
                }
              "
              :on-error="
                (response, file, fileList) => {
                  fileError(1, response, file, fileList);
                }
              "
              :on-delete="
                file => {
                  onFileDelete(1, file);
                }
              "
              :file-list="fileListBusLicense"
              :auto-upload="true"
              :limit="1"
              :action="importFileUrl"
              file-ref="fileRef2"
              :handlePictureCardPreview="
                (file, fileList) => {
                  handlePictureCardPreview(file, fileList, 1);
                }
              "
              :before-upload="
                file => {
                  return beforeAvatarUpload(1, file);
                }
              "
              style="height: 86px"
            ></el-file-upload>
          </div>
          <p
            style="
              font-size: 13px;
              color: #9b9b9b;
              line-height: 18px;
              padding-top: 8px;
            "
          >
            准备的资料请加盖公司公章（鲜章）
          </p>
        </el-form-item>
        <span class="text">法人授权委托书</span>
        <el-form-item label="资质上传：" prop="legalAuthProxyId">
          <div style="height: 88px">
            <el-file-upload
              :on-change="
                (file, fileList) => {
                  changeFile(2, file, fileList);
                }
              "
              :on-success="
                (response, file, fileList) => {
                  handleSuccess(2, response, file, fileList);
                }
              "
              :on-error="
                (response, file, fileList) => {
                  fileError(2, response, file, fileList);
                }
              "
              :on-delete="
                file => {
                  onFileDelete(2, file);
                }
              "
              :file-list="fileListPowerOfAttorney"
              :auto-upload="true"
              :limit="1"
              :action="importFileUrl"
              file-ref="fileRef2"
              :handlePictureCardPreview="
                (file, fileList) => {
                  handlePictureCardPreview(file, fileList, 2);
                }
              "
              :before-upload="
                file => {
                  return beforeAvatarUpload(2, file);
                }
              "
              style="height: 86px"
            ></el-file-upload>
          </div>
          <p class="commonTxt">
            请先下载
            <a
              :href="downFileUrl"
              download="开发者注册法人授权委托书模板.doc"
              target="_blank"
              >开发者注册法人授权委托书模板</a
            >
            ，按要求填写后将文件扫描上传
          </p>
        </el-form-item>
      </el-form>
      <el-form
        ref="ruleForm2"
        :model="form2"
        :rules="rules2"
        label-width="135px"
        class="demo-ruleForm"
      >
        <el-card-title title="法定代表人" />
        <el-form-item label="姓名：" prop="legalContactName">
          <el-input
            v-model.trim="form2.legalContactName"
            class="input-long"
            placeholder="请输入姓名"
            maxlength="50"
          />
        </el-form-item>
        <el-form-item label="证件类型：" prop="idType">
          <el-select v-model="form2.idType" placeholder="请选择">
            <el-option
              v-for="item in idTypeOption"
              :key="item.dicKey"
              :label="item.dicValue"
              placeholder="身份证"
              :value="item.dicKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证件号码：" prop="idNumber">
          <el-input
            v-model.trim="form2.idNumber"
            class="input-long"
            placeholder="请输入证件号码"
            maxlength="18"
          />
        </el-form-item>
      </el-form>
      <el-form
        ref="ruleForm3"
        :model="form3"
        :rules="rules3"
        label-width="135px"
        class="demo-ruleForm"
        style="position: relative"
      >
        <el-card-title title="联系人" />
        <el-form-item label="姓名：" prop="contactName">
          <el-input
            v-model.trim="form3.contactName"
            class="input-long"
            placeholder="请输入姓名"
            maxlength="50"
          />
        </el-form-item>

        <el-form-item prop="mobile" label="手机号：">
          <div class="inputAuthCodeBox">
            <el-input
              type="tel"
              label="手机号："
              maxlength="11"
              class="inputAuthCode"
              placeholder="请输入手机号"
              v-model.number="form3.mobile"
            ></el-input>
            <div class="countDown" v-show="show" @click="getTestCode">
              获取验证码
            </div>
            <div class="countDown" ref="countDown" v-show="!show">
              {{ second }}秒
            </div>
          </div>
        </el-form-item>

        <el-form-item label="短信验证码：" prop="inputAuthCode">
          <el-input
            v-model="form3.inputAuthCode"
            class="input-long"
            placeholder="请输入验证码"
            maxlength="6"
          />
        </el-form-item>
        <div class="islider" v-if="isCode">
          <Slider
            @close="isCode = false"
            :log="true"
            @getImg="getImg"
            @validImg="validImg"
          ></Slider>
        </div>
      </el-form>
      <div class="anty">
        <el-checkbox v-model="tyu"
          ><p>
            我已阅读并接受 <span>《开放平台开发者入网协议》</span>
          </p></el-checkbox
        >
      </div>

      <el-button type="primary" class="tjg" @click="submit" :disabled="!tyu"
        >提交</el-button
      >
    </div>
    <el-dialog :visible.sync="dialogVisible" width="80%">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import {
  developerReg,
  sendVerCode,
  qryDeveloperInfo,
  updateDeveloper,
  getImageVerifyCode
} from "@/api/register";
import imgBase64 from "@/utils/img-base64";
import validators from "@/utils/validators";
import Slider from "./slider";
window.onbeforeunload = function (e) {
  e = e || window.event;
  // 兼容IE8和Firefox 4之前的版本
  if (e) {
    e.returnValue = "关闭提示";
  }
  // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
  return "关闭提示";
};

export default {
  props: ["companyMessage"],
  components: {
    Slider
  },
  data() {
    return {
      followcheckedx: 0,
      followcheckedy: 0,
      tyu: false,
      second: 59,
      timer: "",
      isCode: false, //拼图滑块
      show: true, //手机验证码的按钮
      dialogVisible: false,
      dialogImageUrl: "",
      isBase64Buslicense: false,
      isBase64Legal: false,
      // fileList: [{percentage: 100,name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}, {percentage: 100,name: 'food2.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}],
      importFileUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/dra/oss/users/signup/uploadFileToOss", // 上传地址
      fileListBusLicense: [],
      fileListPowerOfAttorney: [],
      idTypeOption: [
        {
          dicKey: "1",
          dicValue: "身份证"
        }
      ],
      isLongValidityStatus: {
        isLongValidityValue: false,
        isLongValidityDisabled: false
      },
      form4: {
        validityStart: "",
        validityEnd: "",
        isLongValidity: 0,
        busLicenseId: "",
        legalAuthProxyId: ""
      },
      form3: {
        contactName: "",
        mobile: "",
        inputAuthCode: ""
      },
      form2: {
        legalContactName: "",
        idType: "",
        idNumber: "",
        developerCode: ""
      },
      form1: {
        companyName: "", // 公司名称
        companyAbbr: "", // 公司简称
        unifiedCode: "", // 统一社会信用代码
        address: "", // 注册地址
        businessTelephone: "", // 公司联系电话
        buslicense: "", // 营业执照文件
        companyDesc: "", // 公司简介
        legalAuthProxy: ""
      },
      rules4: {
        validityStart: [
          {
            required: true,
            message: "请输入有效期",
            trigger: ["change"]
          }
        ],
        busLicenseId: {
          required: true,
          message: "请上传营业执照",
          trigger: ["blur"]
        },
        legalAuthProxyId: {
          required: true,
          message: "请上传法人授权委托书",
          trigger: ["blur"]
        }
      },
      rules3: {
        inputAuthCode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: ["blur"]
          },
          {
            message: "验证码格式不正确",
            trigger: ["blur"],
            pattern: /\d/
          }
        ],
        contactName: [
          {
            required: true,
            message: "联系人姓名不能为空",
            trigger: ["blur"]
          },
          {
            message: "联系人名称格式不正确",
            trigger: ["blur"],
            pattern: /^[^&]{0,50}$/
          }
        ],
        mobile: [
          {
            required: true,
            message: "联系人手机号不能为空",
            trigger: ["blur"]
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式不正确",
            trigger: ["blur"]
          }
        ]
      },
      rules2: {
        legalContactName: [
          {
            required: true,
            message: "法定代表人名称不能为空",
            trigger: ["blur"]
          },
          {
            message: "法定代表人名称格式不正确",
            pattern: /^[^&]{0,50}$/,
            trigger: ["blur"]
          } // 证件号码
        ], // 法定代表人姓名
        idType: {
          required: true,
          message: "证件类型不能为空",
          trigger: ["change"]
        }, // 证件类型

        idNumber: [
          {
            required: true,
            message: "证件号码不能为空",
            trigger: ["blur"]
          },
          {
            message: "证件号码格式不正确",
            pattern: /^[A-Z0-9]{18}$/,
            trigger: ["blur"]
          } // 证件号码
        ]
      },
      rules1: {
        companyName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: ["blur"]
          },
          {
            pattern: /^[\u4e00-\u9fa5()（）]+$/,
            message: "只能输入中文、括号（中英文）",
            trigger: ["blur"]
          }
        ],

        companyAbbr: [
          {
            required: true,
            message: "请输入公司简称",
            trigger: ["blur"]
          },
          {
            pattern: /^((?!\/|\?|？|{|}|<|>).)*$/,
            message: "不能输入这些 /?{}<> 特殊字符",
            trigger: ["blur"]
          }
        ],
        unifiedCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur"]
          },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]+$/,
            message: "请输入数字、大写英文（不含I\\O\\Z\\S\\V)",
            trigger: ["blur"]
          }
        ],
        address: {
          required: true,
          message: "请输入注册地址",
          trigger: ["blur"]
        },
        businessTelephone: [
          {
            required: true,
            message: "请输入公司联系电话",
            trigger: ["blur"]
          },
          {
            validator: validators.mobileTel,
            message: "请输入正确的公司联系电话",
            trigger: ["blur"]
          }
        ],
        scanFile: [
          {
            required: true,
            message: "请上传营业执照",
            trigger: "change"
          }
        ]
      },
      uploadFileBusLicense: {},
      uploadFilePowerOfAttorney: {},
      uploadFileBusLicenseSuccess: true,
      uploadFilePowerOfAttorneySuccess: true,
      downFileUrl: `${this.$addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/dra/devc/users/signup/download?uploadId=A83AA9C4082C2B260045EB144506CD864E26F51D14A83DC5`
    };
  },
  created() {
    if (sessionStorage.ww) {
      let param = JSON.parse(sessionStorage.ww);
      if (param) {
        this.qryDeveloperInfo(param);
      }
    }
  },
  methods: {
    handleValidityCheckbox(data) {
      if (data) {
        this.isLongValidityStatus.isLongValidityValue = true;
        this.isLongValidityStatus.isLongValidityDisabled = true;
        this.form4.validityEnd = "";
        this.form4.isLongValidity = 1;
      } else {
        this.isLongValidityStatus.isLongValidityValue = false;
        this.isLongValidityStatus.isLongValidityDisabled = false;
        this.form4.isLongValidity = 0;
      }
    },
    createImageUrl(oldUrl, type) {
      let fileType = [
        { type: "xls,xlsx", base64: imgBase64.xls },
        { type: "doc,docx", base64: imgBase64.doc },
        { type: "zip,rar", base64: imgBase64.zip },
        { type: "txt", base64: imgBase64.txt },
        { type: "pdf", base64: imgBase64.pdf }
      ];

      let buslicenseUrl = oldUrl;
      let urlFileTypeArr = buslicenseUrl.split("?")[0].split(".");
      let urlFileType = urlFileTypeArr[urlFileTypeArr.length - 1];
      let imgUrl = "";
      let isBase64 = false;
      fileType.forEach(itemBase => {
        if (itemBase.type.includes(urlFileType.toLowerCase())) {
          imgUrl = itemBase.base64;
          isBase64 = true;
        }
      });
      this[type] = isBase64;
      return imgUrl;
    },
    qryDeveloperInfo(param) {
      qryDeveloperInfo(param).then(res => {
        let resData = res.data.data;
        for (let i = 1; i < 5; i++) {
          for (let key in this["form" + i]) {
            this["form" + i][key] = resData[key];
          }
        }

        this.form2.idType = "1";
        let imgUrl = this.createImageUrl(
          resData.buslicense,
          "isBase64Buslicense"
        );
        if (imgUrl) {
          this.fileListBusLicense.push({ url: imgUrl, percentage: 100 });
        } else {
          this.fileListBusLicense.push({
            url: resData.buslicense,
            percentage: 100
          });
        }
        this.dialogImageUrl = resData.buslicense;

        let legalAuthImgUrl = this.createImageUrl(
          resData.legalAuthProxy,
          "isBase64Legal"
        );
        if (legalAuthImgUrl) {
          this.fileListPowerOfAttorney.push({
            url: legalAuthImgUrl,
            percentage: 100
          });
        } else {
          this.fileListPowerOfAttorney.push({
            url: resData.legalAuthProxy,
            percentage: 100
          });
        }

        if (resData.isLongValidity === 1) {
          this.isLongValidityStatus.isLongValidityValue = true;
          this.isLongValidityStatus.isLongValidityDisabled = true;
        } else {
          this.isLongValidityStatus.isLongValidityValue = false;
          this.isLongValidityStatus.isLongValidityDisabled = false;
        }
      });
    },
    // 获取滑动验证码的图片
    getImg(callback) {
      getImageVerifyCode({}).then(
        res => {
          callback(res.data);
        },
        error => {
          callback(error);
        }
      );
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.handleLogin(blcokLeft, id, callback); // 登陆请求方法
    },
    handleLogin(blcokLeft, id, callback) {
      if (this.form3.mobile) {
        if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form3.mobile)) {
          // this.$refs.countDown.style.backgroundColor = 'rgba(242, 242, 242, 1)'
          // this.$refs.countDown.style.color = 'rgba(153, 153, 153, 1)'
          this.$refs.countDown.style.cursor = "no-drop";
          const TIME_COUNT = 59;
          this.second = TIME_COUNT;
          this.show = false;
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            if (this.second > 0 && this.second <= TIME_COUNT) {
              this.second--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
          sendVerCode({
            mobile: this.form3.mobile,
            captchaVail: {
              x: blcokLeft, // 手动定位返回的值
              catuid: id // 后台返回的id，再传回去
            }
          })
            .then(res => {
              if (res.data.code === "0") {
                callback({ data: true });
                this.isCode = false;
                this.show = false;
                // if (res.data.message.includes('成功')) {
                //   callback({data:true});
                //   this.isCode = false;
                //   this.show = false;
                // } else {
                //   clearInterval(this.timer)
                //   this.second = 59
                //   callback({data:false,message:res.data.message});
                //   this.isCode = true;
                //   this.show = true;
                // }
              } else {
                clearInterval(this.timer);
                this.second = 59;
                callback({ data: false, message: res.data.message });
                this.isCode = true;
                this.show = true;
              }
              // else {
              //   callback({data:false,message:res.data.message});
              //   this.isCode = true;
              //   this.show = true;
              //   // clearInterval(this.timer)
              //   // this.second = 59
              //   // this.$message({
              //   //   message: res.data.message,
              //   //   type: 'error',
              //   //   showClose: true,
              //   //   ccuiCustom: true
              //   // })
              // }
            })
            .catch(errMessage => {
              this.show = true;
              clearInterval(this.timer);
              this.second = 59;
            });
        }
      }
    },
    getTestCode() {
      if (this.form3.mobile) {
        if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.form3.mobile)) {
          this.isCode = true;
        }
      } else {
        this.$message({
          message: "请输入手机号",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    submit() {
      let testArr = [];
      for (let i = 1; i < 5; i++) {
        this.$refs["ruleForm" + i].validate(valid => {
          if (valid) {
            testArr.push(true);
          }
        });
      }
      if (
        !this.uploadFileBusLicenseSuccess ||
        !this.uploadFilePowerOfAttorneySuccess
      ) {
        this.$message.closeAll();
        this.$message({
          message: "资质文件上传中,请稍等!",
          type: "error",
          showClose: true,
          ccuiCustom: true
        });
        return;
      }
      if (testArr.length === 4) {
        let formData = {
          ...this.form1,
          ...this.form2,
          ...this.form3,
          ...this.form4
        };
        if (this.form4.isLongValidity !== 1 && this.form4.validityEnd === "") {
          this.$message({
            message: "有效期为非长期必须选择结束日期!",
            type: "error",
            showClose: true,
            ccuiCustom: true
          });
          return;
        }
        this.tyu = false;
        setTimeout(() => {
          this.tyu = true;
        }, 2000);
        if (sessionStorage.ww) {
          updateDeveloper(formData).then(res => {
            if (res.data.code === "0") {
              this.$emit("next");
            } else {
              this.tyu = false;
            }
            console.log(res);
          });
        } else {
          developerReg(formData).then(res => {
            if (res.data.code === "0") {
              this.$emit("next");
            } else {
              this.tyu = false;
            }

            console.log(res);
          });
        }
      }
    },

    handlePictureCardPreview(file, fileList, type) {
      if (type === 1) {
        if (this.isBase64Buslicense) {
          this.$message({
            message: "该文件类型不支持预览",
            type: "warning",
            offset: this.messageHeight
          });
        } else {
          this.dialogVisible = true;
          this.dialogImageUrl = fileList[0].url;
        }
      } else {
        if (this.isBase64Legal) {
          this.$message({
            message: "该文件类型不支持预览",
            type: "warning",
            offset: this.messageHeight
          });
        } else {
          this.dialogVisible = true;
          this.dialogImageUrl = fileList[0].url;
        }
      }
    },
    // 附件信息上传之前的钩子
    beforeAvatarUpload(type, file) {
      debugger;
      let fileNameBefore = file.name;
      let lastName = fileNameBefore.split(".").pop().toLowerCase();
      console.log(lastName);
      if (
        lastName === "jpg" ||
        lastName === "png" ||
        lastName === "jpeg" ||
        lastName === "gif" ||
        lastName === "xls" ||
        lastName === "xlsx" ||
        lastName === "doc" ||
        lastName === "docx" ||
        lastName === "pdf"
      ) {
      } else {
        // console.log(lastName !== 'jpg' )
        this.$message({
          message:
            "上传文件支持格式：.jpg .png .jpeg .gif 每个不超过5M，.xls .xlsx .doc .docx .pdf每个不超过15M",
          type: "error",
          offset: this.messageHeight
        });
        return false;
      }
      // console.log("fileList2:", file);
      const isJPG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      const isLt15M = file.size / 1024 / 1024 < 15;
      if (isJPG || isGIF || isPNG) {
        if (!isLt5M) {
          this.$message({
            message: "上传图片大小不能超过 5MB!",
            type: "error",
            offset: this.messageHeight
          });
          return false;
        }
        if (type === 1) {
          this.isBase64Buslicense = false;
        } else {
          this.isBase64Legal = false;
        }
      } else {
        if (!isLt15M) {
          this.$message({
            message: "上传文件大小不能超过 15MB!",
            type: "error",
            offset: this.messageHeight
          });
          return false;
        }
        if (type === 1) {
          this.isBase64Buslicense = true;
        } else {
          this.isBase64Legal = true;
        }
      }
      if (type === 1) {
        this.uploadFileBusLicenseSuccess = false;
      } else {
        this.uploadFilePowerOfAttorneySuccess = false;
      }
      return true;
    },
    // 附件信息上传
    changeFile(type, file, fileList) {
      if (type === 1) {
        this.fileListBusLicense = fileList;
      } else {
        this.fileListPowerOfAttorney = fileList;
      }

      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name.split(".").pop().toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(fileList[i].name.split(".").pop().toLowerCase()) !==
          -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },
    handleSuccess(type, response, file, fileList) {
      if (type === 1) {
        this.form4.busLicenseId = response.data[0].uploadId;
        this.form4.buslicense = response.data[0].downloadUrl;
        this.uploadFileBusLicenseSuccess = true;
        this.createImageUrl(response.data[0].downloadUrl, "isBase64Buslicense");
      } else {
        this.form4.legalAuthProxyId = response.data[0].uploadId;
        this.form4.legalAuthProxy = response.data[0].downloadUrl;
        this.uploadFilePowerOfAttorneySuccess = true;
        this.createImageUrl(response.data[0].downloadUrl, "isBase64Legal");
      }

      // busLicenseId: '', // 营业执照ID
      // buslicense:'', //营业执照文件
      // this.uploadFile.uploadId = response.data[0].uploadId
      // this.uploadFile.fileType = 1
      // this.uploadFile.fileName = '营业执照'
      // this.uploadFile.fileAddress =
      //   response.data[0].downloadUrl
      // this.uploadFile.fileSize = response.data[0].fileSize
    },
    fileError(type, response, file, fileList) {
      // console.log();
      if (type === 1) {
        this.fileListBusLicense = [];
        this.uploadFileBusLicenseSuccess = true;
      } else {
        this.fileListPowerOfAttorney = [];
        this.uploadFilePowerOfAttorneySuccess = true;
      }
      this.$message({
        message: "文件上传失败，请重新上传",
        type: "warning",
        offset: this.messageHeight
      });
    },
    // 删除附件信息
    onFileDelete(type, file) {
      if (type === 1) {
        this.fileListBusLicense.splice(file, 1);
        this.uploadFileBusLicense.uploadId = "";
      } else {
        this.fileListPowerOfAttorney.splice(file, 1);
        this.uploadFilePowerOfAttorney.uploadId = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}

.remarkItem {
  position: relative;

  span {
    position: absolute;
    right: -286px;
    width: 266px;
  }

  .nameTipCenter {
    top: 7px;
  }
}

.perfectingInformation {
  margin: 0 auto;

  .detailedInformation {
    // width: 92.1%;
    // min-width: 1180px;
    width: 1180px;
    margin: 0 auto;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // padding-left: 154px;
    .el-card-title {
      /deep/ .details-title {
        margin-left: 20px;
      }
    }

    .el-form {
      .el-form-item {
        margin: 20px 0 0 45px;
        // color: rgba(208, 2, 27, 1);

        .format {
          font-size: 13px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: rgba(155, 155, 155, 1);
          line-height: 17px;
        }

        /deep/ .el-form-item__label {
          padding: 1px 2px 0 0;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
        }

        /deep/ .el-form-item__content {
          .input-long {
            width: 430px;
          }

          .input-short {
            width: 430px;
          }

          .el-input__inner {
            width: 430px;
          }

          .el-textarea {
            font-size: 13px;
            width: 430px;
            color: rgba(74, 74, 74, 1);
            font-family: PingFangSC-Regular, PingFangSC;
            font-weight: 400;
            line-height: 17px;

            &:-ms-input-placeholder {
              font-size: 13px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(155, 155, 155, 1);
            }
          }
        }
      }
    }
  }

  .footer {
    margin-left: 390px;
    display: flex;
    height: 80px;
    align-items: center;
    justify-content: center;

    .left-btn {
      width: 240px;
      height: 40px;
      border-radius: 4px;
      margin-right: 20px;

      span {
        span {
          font-size: 16px;
          line-height: 15px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
        }
      }
    }

    .right-btn {
      width: 400px;
      height: 40px;
      border-radius: 4px;

      span {
        span {
          font-size: 16px;
          line-height: 15px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
        }
      }
    }
  }
}

.nameTip,
.codeTip1,
.codeTip2 {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 15px;
}

.el-radio:nth-child(2) {
  margin-left: 30px;
}

.footer .btn {
  background-color: rgba(255, 20, 47, 1);
  border-color: rgba(255, 20, 47, 1);
}

.uploadInfo {
  padding-top: 17px;
  position: relative;
}

.safe {
  width: 800px;
  margin-bottom: 16px;
}

.safe .text {
  font-size: 13px;
  font-family: PingFangSC;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 48px;
}

.licenseWebsite {
  margin-left: 56px;
}

.demonstration {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 119px;
}

.block {
  margin-top: 20px;
  position: relative;
}

.mustInfoY {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -66px;
  top: 2px;
  font-size: 14px;
  display: inline;
}

.mustInfo {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -130px;
  top: 0px;
  font-size: 14px;
  display: inline;
}

.mustInfoT {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -104px;
  top: 2px;
  font-size: 14px;
  display: inline;
}

.mustInfoG {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -90px;
  top: 2px;
  font-size: 14px;
  display: inline;
}

.mustInfoS {
  color: #f56c6c !important;
  margin-right: 4px;
  position: absolute;
  left: -78px;
  top: 0px;
  font-size: 14px;
  display: inline;
}

.regNum::before {
  left: 43px;
}

.orgCode::before {
  left: 32px;
}

.taxCode::before {
  left: 32px;
}

.el-date-editor--date {
  width: 140px;
  height: 30px;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
}

/deep/ .checkBox {
  margin-left: 28px;

  /deep/ .el-checkbox__label {
    position: relative;

    top: 1px;
  }
}

/deep/ .el-checkbox__label {
  padding-left: 10px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  font-weight: 600;
  color: rgba(216, 216, 216, 1);
  background-color: rgba(223, 223, 223, 1);
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar-uploader {
  width: 80px;
  height: 80px;
  padding-bottom: 24px;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.commonTxt {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 6px;
  margin-top: 10px;
}

.commonTxt a {
  color: rgba(0, 137, 239, 1);
  cursor: pointer;
}

.lastYearTurnoverTxt {
  font-size: 13px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}

.addBox {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 20, 47, 1);
  line-height: 18px;
  margin-left: 50px;
  margin-top: 10px;
  cursor: pointer;
  width: 20%;
}

.intelligence {
  margin-left: 94px;
}

.companyInfoTxt {
  font-size: 13px;
  font-family: PingFang-SC-Regular, PingFang-SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}

.el-card-title {
  margin-top: 20px;
}

.website {
  margin: 20px 0 0 54px !important;
}

.scanFile3 {
  padding-left: 68px;
}

/deep/ .el-input__inner {
  padding: 0 10px !important;
}

/deep/ .el-textarea__inner {
  padding: 5px 10px !important;
  min-height: 64px !important;
}

/deep/ .checkClass {
  position: relative;

  input::-webkit-input-placeholder {
    color: #4a4a4a;
  }

  input::-moz-input-placeholder {
    color: #4a4a4a;
  }

  input::-ms-input-placeholder {
    color: #4a4a4a;
  }
}

/deep/ .checkClassRules {
  position: relative;
}
</style>
<style>
.el-radio__input.is-checked .el-radio__inner {
  background-color: rgba(59, 136, 253, 1);
  border-color: rgba(59, 136, 253, 1);
}

.el-radio__input.is-checked + .el-radio__label {
  color: rgba(74, 74, 74, 1);
}

.el-radio__inner:hover {
  border: 1px solid rgba(59, 136, 253, 1);
}

.el-radio__label {
  width: 65px;
  height: 17px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  line-height: 17px;
}

.el-select-dropdown__item span {
  padding-left: 9px;
}

.el-upload--picture-card {
  width: 80px;
  height: 80px;
  padding-bottom: 24px;
  font-size: 28px;
  font-weight: 600;
  color: rgba(216, 216, 216, 1);
  background-color: rgba(223, 223, 223, 1);
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.el-input__inner,
.el-select,
.el-cascader {
  width: 430px;
}

.selectDate input {
  padding: 0 26px !important;
}

.el-file-upload .file .file-list {
  margin: 0 !important;
}

.el-file-upload .file .file-list li {
  margin-right: 18px !important;
}

/deep/ .inputPad .el-input__inner {
  padding-left: 82px;
}

/deep/ .inputBe {
  position: absolute;
  /* z-index: 999; */
  width: 71px;
  height: 38px;
  background: transparent;
  border-right: 1px solid rgba(204, 204, 204, 1);
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
  text-align: center;
  line-height: 40px;
  left: 1px;
  top: 1px;
}

.inputAuthCode {
  width: 320px;
  margin: 0;
}

.inputAuthCodeBox {
  display: flex;
}

.countDown {
  width: 82px;
  height: 31px;
  /* background: rgba(242, 242, 242, 1); */

  border-radius: 4px;
  border: 1px solid #0089ef;
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #0089ef;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  margin-left: 28px;
}

.anty p {
  font-size: 13px;
  color: #9b9b9b;
}

.anty {
  padding-left: 380px;
  margin: 20px 0;
}

.anty p span {
  color: #0089ef;
}

.detailedInformation form {
  padding-left: 200px;
}

.tjg {
  width: 500px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.commonTxt {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: rgba(155, 155, 155, 1);
  line-height: 8px;
  margin-top: 10px;
  padding-bottom: 8px;
}

.commonTxtTip {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #0089ef;
  line-height: 6px;
  margin-top: 10px;
  margin-left: 20px;
  margin-bottom: 10px;
}

.text {
  font-size: 13px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(74, 74, 74, 1);
  line-height: 18px;
  margin-left: 48px;
}
.islider {
  width: 400px;
  height: 265px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(201, 201, 201, 0.5),
    4px 0px 4px 0px rgba(229, 229, 229, 0.5);
  position: absolute;
  top: -70%;
  left: 50%;
}
.islider::before {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, 0.1);
}
.islider::after {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.2));
}
</style>:
